import { match } from 'path-to-regexp';

const patterns = [
	['/', '/'],
	['/inbox', '/'],
	['/inbox/personal', '/'],
	['/inbox/manager', '/inbox/manager'],
	['/manager', '/manager'],
	['/manager/inbox', '/manager/inbox'],
	['/analytics', '/analytics'],
	['/analytics/department', '/analytics/department'],
	['/analytics/employee', '/analytics/employee'],
	['/analytics/engagement', '/analytics/engagement'],
	['/analytics/engagement/topics', '/analytics/engagement/topics'],
	['/analytics/engagement/questions', '/analytics/engagement/questions'],
	['/analytics/v2', '/analytics/v2'],
	['/analytics/v2', '/analytics/v2\\?interval=(.*)&cursor=(.*)'],
	[
		'/analytics/v2/metric/:metricGroupID/:metricID',
		'/analytics/v2/metric/:metricGroupID/:metricID',
	],
	[
		'/analytics/v2/metric/:metricGroupID/:metricID',
		'/analytics/v2/metric/:metricGroupID/:metricID\\?interval=(.*)&cursor=(.*)',
	],
	[
		'/analytics/v2/metric/:metricGroupID/:metricID/:detailsID',
		'/analytics/v2/metric/:metricGroupID/:metricID/:detailsID',
	],
	[
		'/analytics/v2/metric/:metricGroupID/:metricID/:detailsID',
		'/analytics/v2/metric/:metricGroupID/:metricID/:detailsID\\?interval=(.*)&cursor=(.*)',
	],
	['/user/:id', '/users/:id'],

	['/external-feedback/:id/respond/:secret', '/v2/feedback/external/:id/respond/:secret'],
	['/feedback/:id/respond', '/feedback/:id/respond'],
	['/user/me/feedback-v2', '/feedback'],
	['/user/me/feedback-v2/outgoing', '/feedback/given'],
	['/', '/feedback/given/:id'],
	['/compliments', '/feedback/compliments'],
	['/compliments/create', '/feedback/compliments/new'],
	['/feedback/compliments/:id', '/feedback/compliments/:id'],
	['/user/:userID/feedback/compliments/:id', '/users/:userID/feedback/compliments/:id'],
	['/user/:id/compliments/give', '/users/:id/feedback/compliments/new'],
	['/user/:id/compliments/thank-you', '/users/:id/feedback/compliments/thank-you'],
	['/user/me/feedback-v2/request', '/feedback/request'],
	['/user/me/feedback-v2/request', '/feedback/request/competencies'],
	['/user/me/feedback-v2/request', '/feedback/request/competencies\\?return=(.*)'],
	['/user/me/feedback-v2/request-from-moment', '/feedback/request-from-moment'],
	['/user/me/feedback-v2/request-from-moment/:momentID', '/feedback/request-from-moment/:momentID'],
	['/user/me/feedback-v2/:id/results', '/feedback/:id'],
	['/user/me/feedback-v2/:requestID/results', '/feedback/:requestID\\?response_id=:responseID'],

	// Personal goals (me)
	['/user/me/goals', '/goals'],
	['/user/me/goals', '/goals/competencies'],
	['/group-goals/create', '/goals/new\\?group_id='],
	['/organization/goals', '/goals/collective'],
	['/organization/goals', '/goals/collective/:id'],
	['/organization/goals', '/goals/collective\\?group_ids=:groupIDs'],
	['/user/me/goals/create-from-moment/:momentID', '/goals/new\\?moment_id=:momentID'],
	['/user/:id/goals/create-from-moment/:momentID', '/users/:id/goals/new\\?moment_id=:momentID'],
	['/organization/goals', '/goals/organization'],
	['/user/me/goals/create-from-template', '/goals/new\\?group_id=:groupID'],
	['/user/me/goals/create-from-template', '/goals/new\\?workspace_id=:workspaceID'],
	['/user/me/goals/create-from-template', '/goals/new'],
	['/user/me/goals/create-from-template', '/goals/new\\?template_id=:template_id'],
	['/user/me/goals/:goalID', '/goals/:goalID'],
	['/user/me/goals/:goalID', '/goals/:goalID/revisions/:revision'],
	['/user/me/goals/:goalID', '/goals/:goalID/revisions/:revision\\?secret=:secret'],
	['/user/me/goals/:goalID', '/goals/:goalID\\?return=(.*)'],
	['/user/me/goals/:goalID/edit', '/goals/:goalID/edit'],

	// Personal conversations
	['/user/me/evaluations-v2', '/conversations'],
	['/user/me/evaluations-v2/:id', '/conversations/:id'],
	['/user/me/evaluations-v2/:id/change-date', '/conversations/:id/change-date'],

	// Notes
	['/notes', '/notes'],
	['/notes\\?collaborator_id=:collaborator_id', '/notes\\?collaborator_id=:collaborator_id'],
	['/notes/archive', '/notes/archive'],
	['/notes/new', '/notes/new'],
	['/notes/new/:collaboratorID', '/notes/new/:collaboratorID'],
	['/notes/:id', '/notes/:id'],
	['/user/:id', '/users/:id/notes'],
	['/user/:id', '/users/:userID/notes/:id'],

	// Learning
	['/learning', '/learning'],
	['/learning/me', '/learning/me'],
	['/learning/proposals', '/learning/proposals'],
	['/learning/calendar', '/learning/calendar'],
	['/learning/calendar/:year/:month', '/learning/calendar/:year/:month'],
	['/learning/event/create', '/learning/events/new'],
	['/learning/event/:id', '/learning/events/:id'],
	['/learning/event/:id/attendees', '/learning/events/:id/attendees'],
	['/learning/event/:id/edit', '/learning/events/:id/edit'],
	['/learning/certificates', '/learning/certificates'],
	['/learning/event/:id/award-certificates', '/learning/event/:id/award-certificates'],

	// Journey
	['/user/me/journey', '/journey'],
	['/user/me/personal-information', '/journey/jobs'],
	['/user/me/personal-information', '/personal-files'],
	['/user/me/personal-information', '/personal-settings'],
	['/user/me/personal-information', '/personal-settings/mission'],
	['/user/me/personal-information', '/personal-settings/language'],
	['/', '/personal-settings/notifications'],
	['/', '/journey/learning/:eventID'],

	// Individual journey (someone else)
	['/user/:id/journey', '/users/:id/journey'],
	['/user/:id/personal-information', '/users/:id/journey/jobs'],
	['/user/:id/personal-information', '/users/:id/personal-files'],
	['/user/:id/journey/goals/:goalID', '/users/:id/journey/goals/:goalID'],
	['/user/:id/journey/learning/:eventID', '/users/:id/journey/learning/:eventID'],

	// Talent review
	['/department/:departmentID/talent-reviews/:id', '/talent-reviews/:id'],
	['/talent-reviews', '/talent-reviews'],
	['/talent-reviews/department/:id/new', '/talent-reviews/department/:id/new'],
	['/talent-reviews/team/:id/new', '/talent-reviews/team/:id/new'],
	['/department/:id/talent-reviews', '/talent-reviews/department/:id'],
	['/team/:id/talent-reviews', '/talent-reviews/team/:id'],
	['/team/:teamID/talent-reviews/:id', '/talent-reviews/:id'],
	['/team/:id/goals', '/goals/collective\\?group_ids=:id'],

	// Individual feedback (someone else)
	['/user/:id/feedback-v2', '/users/:id/feedback'],
	['/user/:id/feedback-v2/outgoing', '/users/:id/feedback/given'],
	['/', '/users/:userID/feedback/given/:id'],
	['/', '/users/:id/feedback/compliments'],
	['/user/:id/feedback-v2/request', '/users/:id/feedback/request'],
	['/user/:id/feedback-v2/request-from-moment', '/users/:id/feedback/request-from-moment'],
	[
		'/user/:id/feedback-v2/request-from-moment/:momentID',
		'/users/:id/feedback/request-from-moment/:momentID',
	],
	['/user/:id/feedback-v2/:requestID/results', '/users/:id/feedback/:requestID'],
	['/user/:id/feedback-v2/:requestID/results', '/users/:id/feedback/:requestID\\?return=(.*)'],
	['/user/:id/feedback-v2/:requestID/respond', '/users/:id/feedback/:requestID/respond'],
	[
		'/user/:id/feedback-v2/:requestID/results',
		'/users/:id/feedback/:requestID\\?response_id=:responseID',
	],

	['/competencies', '/competencies'],
	['/competencies/:jobTitleID', '/competencies/:jobTitleID'],
	['/competencies/search/:id', '/competencies/search/:id'],
	['/users/:id/competencies', '/users/:id/competencies'],
	['/users/:id/competencies/:jobTitleID', '/users/:id/competencies/:jobTitleID'],
	['/job-positions/:id', '/job-positions/:id'],

	// Individual goals (someone else)
	['/user/:id/goals', '/users/:id/goals'],
	['/user/:id/goals/:goalID', '/users/:id/goals/:goalID'],
	['/user/:id/goals/:goalID', '/users/:id/goals/:goalID\\?return=(.*)'],
	['/', '/users/:id/goals/new'],
	['/', '/users/:id/goals/new\\?template_id=:template_id'],
	['/user/:id/goals/:goalID/edit', '/users/:id/goals/:goalID/edit'],

	// Individual conversations (someone else)
	['/user/:id/evaluations-v2', '/users/:id/conversations'],
	['/user/:id/evaluations-v2/:conversationID', '/users/:id/conversations/:conversationID'],
	[
		'/user/:id/evaluations-v2/:conversationID',
		'/users/:id/conversations/:conversationID\\?return=(.*)',
	],
	[
		'/user/:id/evaluations-v2/:conversationID/print',
		'/users/:id/conversations/:conversationID/print',
	],
	[
		'/user/:id/evaluations-v2/:conversationID/change-date',
		'/users/:id/conversations/:conversationID/change-date',
	],
	['/user/me/evaluations-v2/request', '/conversations/request'],
	['/user/me/evaluations-v2/create', '/conversations/create'],
	['/user/me/evaluations-v2/request-from-moment', '/conversations/request-from-moment'],
	[
		'/user/me/evaluations-v2/request-from-moment/:momentID',
		'/conversations/request-from-moment/:momentID',
	],
	[
		'/user/:id/evaluations-v2/request-from-moment/:momentID',
		'/users/:id/conversations/request-from-moment/:momentID',
	],
	[
		'/user/:id/evaluations-v2/create-from-moment/:momentID',
		'/users/:id/conversations/create-from-moment/:momentID',
	],

	// Engagement
	['/engagement/:id', '/engagement/:id'],
	['/engagement/:id/:question', '/engagement/:id/:question'],
	['/engagement/:id\\?secret=:secret', '/engagement/:id\\?secret=:secret'],
	['/engagement/:id/:question\\?secret=:secret', '/engagement/:id/:question\\?secret=:secret'],
	['/engagement-replies/:answerID', '/engagement-replies/:answerID'],

	['/logout', '/logout'],

	['/authentication', '/authentication'],
	['/authentication\\?m', '/authentication\\?m'],

	['/settings', '/settings'],

	['/settings/billing', '/settings/billing'],
	['/settings/billing/success', '/settings/billing/success'],

	['/settings/engagement', '/settings/engagement'],
	['/settings/engagement/categories/:id', '/settings/engagement/categories/:id'],
	['/settings/engagement/surveys/:id', '/settings/engagement/surveys/:id'],

	['/settings/departments', '/settings/organization/departments'],
	['/settings/departments', '/settings/organization'],
	['/settings/departments/create', '/settings/organization/departments/new'],
	['/settings/departments/:id', '/settings/organization/departments/:id'],
	['/settings/teams', '/settings/organization/teams'],
	['/settings/teams', '/settings/organization'],
	['/settings/teams/create', '/settings/organization/teams/new'],
	['/settings/teams/:id', '/settings/organization/teams/:id'],
	['/settings/teams/:id/edit', '/settings/organization/teams/:id'],
	['/employees', '/settings/organization/employees'],
	['/settings/employees', '/settings/employees'],
	['/settings/employees/new', '/settings/employees/new'],
	['/settings/employees/:id', '/settings/employees/:id'],
	['/settings/employees/:id/informations', '/users/:id/settings'],
	[
		'/settings/employees/:id/informations/job-positions/:jobPositionID',
		'/users/:id/settings/job-positions/:jobPositionID',
	],
	['/settings/employees/:id/roles', '/users/:id/settings/roles'],
	[
		'/settings/employees/:id/roles/assign-group-role',
		'/users/:id/settings/roles/assign-group-role',
	],
	['/settings/employees/:id/roles/assign-user-role', '/users/:id/settings/roles/assign-user-role'],
	[
		'/settings/employees/:id/roles/assign-workspace-role',
		'/users/:id/settings/roles/assign-workspace-role',
	],
	[
		'/settings/employees/:id/roles/revoke-role/:roleTargetType/:roleTargetID/:roleID',
		'/users/:id/settings/roles/revoke-role/:roleTargetType/:roleTargetID/:roleID',
	],
	['/settings/modules', '/settings/organization/modules'],
	['/settings/theme', '/settings/organization/theme'],
	['/settings/goal-drivers', '/settings/organization/drivers'],
	['/settings/bulk', '/settings/bulk'],

	['/settings/job-titles', '/settings/jobs'],
	['/settings/job-titles', '/settings/jobs/titles'],
	['/settings/job-titles/create', '/settings/jobs/titles/new'],
	['/settings/job-titles/:id', '/settings/jobs/titles/:id'],
	['/settings/job-levels', '/settings/jobs/levels'],
	['/settings/job-levels/create', '/settings/jobs/levels/new'],
	['/settings/job-levels/:id', '/settings/jobs/levels/:id'],

	['/settings/notifications', '/settings/notifications'],
	['/settings/notifications/email', '/settings/notifications/email'],
	['/settings/notifications/sent-emails', '/settings/notifications/sent-emails'],

	['/settings/cycle-templates', '/settings/cycles'],
	['/settings/cycle-templates/create', '/settings/cycles/new'],
	['/settings/cycle-templates/:id', '/settings/cycles/:id'],
	['/settings/cycle-templates/create/moments/:momentID', '/settings/cycles/new/moments/:momentID'],
	['/settings/cycle-templates/:id/moments/:momentID', '/settings/cycles/:id/moments/:momentID'],

	['/settings/competencies', '/settings/competencies'],
	['/settings/competencies/create', '/settings/competencies/new'],
	['/settings/competencies/create/levels', '/settings/competencies/new/levels'],
	['/settings/competencies/:id/levels', '/settings/competencies/:id/levels'],
	['/settings/competencies/:id', '/settings/competencies/:id'],

	['/settings/goals', '/settings/goals'],
	['/settings/goals/create', '/settings/goals/new'],
	['/settings/goals/:id', '/settings/goals/:id'],

	['/settings/feedback-v2', '/settings/feedback-v2'],
	['/settings/feedback-v2/:templateID', '/settings/feedback-v2/:templateID'],

	['/settings/feedback/categories', '/settings/feedback/categories'],
	['/settings/feedback/categories', '/settings/feedback'],
	['/settings/feedback/questions', '/settings/feedback/questions'],
	['/settings/feedback/templates', '/settings/feedback/templates'],
	['/settings/feedback/templates/create', '/settings/feedback/templates/new'],
	['/settings/feedback/templates/:id', '/settings/feedback/templates/:id'],

	['/settings/evaluation-forms', '/settings/conversations'],
	['/settings/evaluation-forms/create', '/settings/conversations/new'],
	['/settings/evaluation-forms/:id', '/settings/conversations/:id'],

	['/settings/talent-reviews', '/settings/talent-reviews'],
	['/settings/talent-reviews/create', '/settings/talent-reviews/new'],
	['/settings/talent-reviews/:id', '/settings/talent-reviews/:id'],

	['/settings/learning', '/settings/learning'],
	['/settings/learning', '/settings/learning/types'],
	['/settings/learning', '/settings/learning/subjects'],
	['/settings/learning', '/settings/learning/certificates'],
	['/settings/learning/certificates/templates/create', '/settings/learning/certificates/new'],
	['/settings/learning/certificates/templates/:id', '/settings/learning/certificates/:id'],

	['/settings/emails', '/settings/emails'],
	['/settings/emails', '/settings/emails/templates'],
	['/settings/sent-emails', '/settings/emails/sent'],

	['/settings/integrations/configuration', '/settings/integrations/configuration'],
	['/settings/integrations/callback', '/settings/integrations/callback'],
	['/settings/integrations/configuration', '/settings/integrations'],
	['/settings/integrations/logs', '/settings/integrations/logs'],
	['/settings/integrations/:id', '/settings/integrations/:id'],
	['/settings/integrations/:id/results/:type', '/settings/integrations/:id/results/:type'],
	[
		'/settings/integrations/:id\\?state=:state&code=:code',
		'/settings/integrations/:id\\?state=:state&code=:code',
	],
	['/settings/failed-sso-attempts', '/settings/integrations/sso'],
	['/settings/failed-sso-attempts', '/settings/integrations/sso/logs'],

	['/settings/workspaces', '/settings/workspaces'],
	['/settings/workspaces/trials', '/settings/workspaces/trials'],
	['/settings/workspaces/archive', '/settings/workspaces/archive'],

	['/settings/roles', '/settings/roles'],
	['/settings/job-positions', '/settings/job-positions'],

	['/settings/advanced', '/settings/advanced'],
	['/development-plan', '/development-plan'],
	['/development-plan/add-goal', '/development-plan/add-goal'],
];

const matchers = new Map(
	patterns.flatMap(([input, output]) => [
		[input, match(input)],
		[output, match(output)],
	]),
);

export function matcher(path: string): string | undefined {
	const params = new URLSearchParams(path.substring(path.indexOf('?')));
	const modal = params.get('modal');

	path = path.replace(/^\/v2/, '');

	if (modal) {
		const prefix = path.substring(0, path.indexOf('?'));
		return rewrite(prefix.replace(/^\/v2/, '')) + '?modal=' + rewrite(modal.replace(/^\/v2/, ''));
	}

	for (const [matcher, regex] of matchers) {
		const result = regex!(path);

		if (result) {
			return matcher;
		}
	}

	return undefined;
}

export function rewrite(path: string): string {
	if (path === '#') {
		return path;
	}

	const params = new URLSearchParams(path.substring(path.indexOf('?')));
	const modal = params.get('modal');

	if (modal) {
		const prefix = path.substring(0, path.indexOf('?'));
		return rewrite(prefix.replace(/^\/v2/, '')) + '?modal=' + rewrite(modal.replace(/^\/v2/, ''));
	}

	for (const [input, output] of patterns) {
		if (matchers.get(output)!(path)) {
			return '/v2' + path;
		}

		const result = matchers.get(input)!(path);

		if (result) {
			let path = output.replace(/\\/g, '');

			for (const key in result.params) {
				path = path.replace(':' + key, (result.params as Record<string, string>)[key]);
			}

			return '/v2' + path;
		}
	}

	return '/v2/unknown';
}

export function rewriteInverse(path: string) {
	if (path === '#') {
		return path;
	}

	for (const [output, input] of patterns) {
		const result = matchers.get(input)!(path);

		if (result) {
			let path = output.replace(/\\/g, '');

			for (const key in result.params) {
				path = path.replace(':' + key, (result.params as Record<string, string>)[key]);
			}

			return path;
		}
	}

	return path;
}
